import Benefit from "./Benefit";
import CollectionDescription from "./CollectionDescription";
import HeroSection from "./HeroSection";

function MintNFT() {
  return (
    <div className="">
      <HeroSection />
      <CollectionDescription />
      <Benefit />
    </div>
  );
}

export default MintNFT;
